import { render, staticRenderFns } from "./LivnessCheckModal.vue?vue&type=template&id=a0b6b012&"
import script from "./LivnessCheckModal.vue?vue&type=script&lang=js&"
export * from "./LivnessCheckModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports